import { listVal } from "@paroi/data-formatters-lib";
import { fetchQuery } from "../api/shared/http-client";
import { type Role, formatRole } from "../helpers/format-roles";

export async function fetchRoles(): Promise<Role[]> {
  const result: any = await fetchQuery("roles");
  result.data = result.data.filter(
    (role: any) => role.name !== "ROLE SUPER ADMIN"
  );
  return listVal(result.data, formatRole);
}
